import React, { useEffect, useState } from "react";
import { Dropdown, Icon } from "semantic-ui-react";

export default function CustomFieldGroupDropdown({
  customFieldGroups,
  onCustomFieldGroupSelect,
  customFieldConfigs,
}) {
  const [customFieldFormOptions, setCustomFieldsFieldFormOptions] = useState(
    []
  );
  const [customFieldFormValue, setCustomFieldsFieldFormValue] = useState([]);

  /**
   * Builds an array of Custom Fields.
   * The result maintains all existing custom fields while updating the selection state
   * of fields in the selected group.
   * @param {string} selectedCustomFieldGroupID
   * @returns {Array<Object>}
   */
  const buildCustomFields = selectedCustomFieldGroupID => {
    const selectedGroup = customFieldGroups.find(
      cfg => cfg.id == selectedCustomFieldGroupID
    ).custom_field_configs;
    const selectedGroupMap = selectedGroup.reduce((map, field) => {
      map[field.id] = field;
      return map;
    }, {});

    return customFieldConfigs.map(customFieldConfig => {
      if (selectedGroupMap[customFieldConfig.id]) {
        return {
          ...customFieldConfig,
          selected: true,
        };
      }
      return {
        ...customFieldConfig,
        selected: customFieldConfig.selected || customFieldConfig.required,
      };
    });
  };

  const handleCustomFieldGroupSelect = (_, data) => {
    const customFields = buildCustomFields(data.value);
    onCustomFieldGroupSelect(customFields);
  };

  useEffect(() => {
    const customFieldFormOptions = customFieldGroups.map(cf => ({
      id: cf.id,
      value: cf.id,
      text: cf.name,
    }));
    setCustomFieldsFieldFormOptions(customFieldFormOptions);
    setCustomFieldsFieldFormValue(
      customFieldGroups.filter(cf => cf.selected).map(cf => cf.id)
    );
  }, [customFieldGroups]);

  return (
    <>
      <Dropdown
        className="button icon scrolling tiny cf-dropdown"
        basic
        search
        text={
          <>
            <Icon name="plus" />
            <strong>Custom Field Groups</strong>
          </>
        }
        name="customFieldGroups"
        options={customFieldFormOptions}
        value={customFieldFormValue}
        onChange={handleCustomFieldGroupSelect}
        selectOnBlur={false}
      />
    </>
  );
}
